import { ApplicationStep1, HouseholdFormData, ReasonFormData } from "../models/classes/ApplicationStep1.class";
import { StructureStatusEnum } from "../models/enum/structure-status.enum";
import { OwnershipReasonEnum } from "../models/enum/ownership-reason.enum";
import { ResidentialStatusEnum } from "../models/enum/residential-status.enum";
import { FlatRoomTypeEnum } from "../models/enum/flat-room-type.enum";
import { Occupier } from "../models/polymer/Occupier.model";
import { Owner } from "../models/polymer/Owner.model";
import { MaritalStatusEnum } from "../models/enum/marital-status.enum";
import { HousingScheme } from "../models/interfaces/housing-scheme.interface";
import { SchemeTypeEnum } from "../models/enum/scheme-type.enum";
import { RelationshipWithOwner } from "./code-converter";
import { MopCheckStatusEnum } from "../models/enum/mop-check-status.enum";
import { SalesCodeTypeEnum } from "../models/enum/sales-code-type.enum";
import { RaceType } from "../models/enum/race.enum";
import { RoleNameType } from "../models/enum/role-name.enum";
import data from "./shared/options.json";
import { StampDutyValuationEnum } from "../models/enum/stamp-duty-valuation.enum";
import { HDBLinks } from "./shared/links";
import { IDTypeEnum } from "../models/enum/id-type.enum";
import { HoldingTypeEnum } from "../models/enum/holding-type.enum";
import { uniq } from "lodash";


export const checkAlphanumeric = (value: string) => {
  const regex = /[^0-9a-zA-Z]+/g; //this will admit letters, numbers and dashes
  // const regexNRIC = /^[A-Z]{1}\d{7}[A-Z]{1}$/g; //this will admit letters, numbers and dashes
  let newValue = value.replace(regex, "");
  return newValue;
};

export const checkNRIC = (nric: string): boolean => {
  const regexNRIC = /^[A-Z]\d{7}[A-Z]$/g; //this will admit letters, numbers and dashes

  if (regexNRIC.test(nric)) {
    //ref : https://ivantay2003.medium.com/creation-of-singapore-identity-number-nric-24fc3b446145
    let uinfin: any = nric;
    const sgList = "ABCDEFGHIZJ";
    const otList = "KLMNPQRTUWX";
    const additional = (() => {
      switch (uinfin[0]) {
        case "T":
          return 4;
        case "G":
          return 4;
        case "M":
          return 3;
        default:
          return 0;
      }
    })();

    let key =
      11 -
      ((Number(uinfin[1]) * 2 +
        Number(uinfin[2]) * 7 +
        Number(uinfin[3]) * 6 +
        Number(uinfin[4]) * 5 +
        Number(uinfin[5]) * 4 +
        Number(uinfin[6]) * 3 +
        Number(uinfin[7]) * 2 +
        additional) %
        11);

    if (uinfin[0] === "S" || uinfin[0] === "T") {
      return uinfin[8] === sgList[key - 1];
    } else if (uinfin[0] === "M" || uinfin[0] === "F" || uinfin[0] === "G") {
      return uinfin[8] === otList[key - 1];
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const checkEmail = (email: string): boolean => {
  const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/g; //this will admit letters, numbers and dashes
  return regexEmail.test(email);
};

export const checkContactNumber = (contact_number: string): boolean => {
  const regexContactNumber = /^[689]\d{7}$/;
  return regexContactNumber.test(contact_number);
};

export const checkDOB = (date: string, ageLimit: number): boolean => {
  let todays_date = new Date();
  let dob_date = new Date(date);
  let ageDiff = todays_date.getFullYear() - dob_date.getFullYear();

  if (!date) {
    return false;
  }
  if (dob_date.getMonth() < todays_date.getMonth()) {
    //Over
  } else if (dob_date.getMonth() > todays_date.getMonth()) {
    //Over
    ageDiff -= 1;
  } else if (dob_date.getMonth() === todays_date.getMonth()) {
    //check Day
    if (todays_date.getDate() >= dob_date.getDate()) {
      //Over
    } else {
      //Not Over
      ageDiff -= 1;
    }
  }

  return ageDiff >= ageLimit;
};

/**
 * @description this function is to check if the owners or occupier is existed or associated with another flat.
 * @param {string[]} nrics - An array of NRICs of "Owner to Occupiers" to be checked.
 * @returns {boolean} - `true` if none of the provided NRICs are associated with another flat,
 *                     `false` if any of the NRICs are already linked to another flat or an error occurs.
 */
const checkOwnerToOccupierFlatStatus = async (nrics: string[], uinfin: string) => {
  return true;
};

const checkSpouseUinfins = (uinfins: string[], proposedMarriedApplicantsUinfin: string[]) => {
  let result = proposedMarriedApplicantsUinfin.map((e,_index)=>{
    return uinfins.includes(e);
  })
  return result.every(e=>e === true);

}

const checkMovingOutMarriageCoupleValid = (householdFormData: HouseholdFormData) => {
    const proposedOwnersMaritalStatuses = householdFormData.incoming_owners.map(item => item.myinfo.marital_status);
    const proposedOccupiersMaritalStatuses = householdFormData.incoming_occupiers.map(item => item.myinfo.marital_status);
    const proposedMaritalStatus = proposedOwnersMaritalStatuses.concat(proposedOccupiersMaritalStatuses);
    
    if(proposedMaritalStatus.filter(item => item === MaritalStatusEnum.married).length % 2 === 0){
      const proposedOwners = householdFormData.incoming_owners.filter(e=>e.myinfo.marital_status === MaritalStatusEnum.married);
      const proposedOccupiers = householdFormData.incoming_occupiers.filter(e=>e.myinfo.marital_status === MaritalStatusEnum.married);
      const proposedOwnersSpouseUinfins = proposedOwners.map(item => item.spouse);
      const proposedOccupiersSpouseUinfins = proposedOccupiers.map(item => item.spouse);
      const proposedSpouseUinfins = proposedOccupiersSpouseUinfins.concat(proposedOwnersSpouseUinfins);
      
      const proposedMarriedApplicantsUinfin = [...proposedOwners.map(e=>e.myinfo.uinfin),...proposedOccupiers.map(e=>e.myinfo.uinfin)];

      if(proposedSpouseUinfins.length === 0){
        return true;
      }
      
      return checkSpouseUinfins(proposedSpouseUinfins, proposedMarriedApplicantsUinfin)
    }
    else{
      return false;
    }
}

const checkIsDecoupling = (data: ApplicationStep1) => {
    const { household, reason } = data;
    const currentOwnersUinfins = household.owners.map(item => item.myinfo.uinfin);
    const proposedOwnerSpouses = household.incoming_owners.map(item => item.spouse);
    const proposedOccupiersUinfins = household.incoming_occupiers.map(item => item.myinfo.uinfin);
    if(reason.change_ownership_reason === OwnershipReasonEnum.renunciation){
      for(const occupierUinfin of proposedOccupiersUinfins){
         const checkOccupierIdType = household.incoming_owners.find(item => item.spouse === occupierUinfin)?.spouse_id_type ?? "";
         if(checkOccupierIdType === IDTypeEnum.uinfin){
            return true;
         }
      }
    }else{
      if(proposedOwnerSpouses.some(item => proposedOccupiersUinfins.includes(item) && currentOwnersUinfins.includes(item))){
        return true;
      }
    }
    return false;
}


const eligibilityScheme = (household:HouseholdFormData, allowBypass35YearsOldCheck: boolean) => {
  const isSoleOwner = household.incoming_owners.length === 1;
  const isDoubled = household.incoming_owners.length + household.incoming_occupiers.length === 2


  const retainingOwners = household.incoming_owners?.filter((owner) => owner.structure_status === StructureStatusEnum.retaining);
  const incomingOwners = household.incoming_owners?.filter((owner) => owner.structure_status === StructureStatusEnum.incoming);
  const retainingOccupiers = household.incoming_occupiers?.filter((occupier) => occupier.structure_status === StructureStatusEnum.retaining);
  const incomingOccupiers = household.incoming_occupiers?.filter((occupier) => occupier.structure_status === StructureStatusEnum.incoming);

  const proposedOwners = [...retainingOwners, ...incomingOwners];
  const proposedOccupiers = [...retainingOccupiers, ...incomingOccupiers];

  if(isSoleOwner){
    const isSolePR = isSoleOwner && household.incoming_owners.some(e => e.myinfo.residential_status === ResidentialStatusEnum.pr);
    const isSoleDivorcee = isSoleOwner && household.incoming_owners.some(e => e.myinfo.marital_status === MaritalStatusEnum.divorced);
    const hasChildInOccupier = household.incoming_occupiers.some(e=> !checkDOB(e.myinfo.dob, 21) && (e.relationship_with_owner === "DA" || e.relationship_with_owner === "SO"));
    const directRelationships = ["HU", "WI", "SW", "FA", "MO", "SM", "SO", "DA"];
    const hasDirectRelationship = household.incoming_occupiers.some(e => directRelationships.includes(e.relationship_with_owner));
    if(hasDirectRelationship){
      return { pass: true, message: "", debug: ""};
    }
    console.log("DEBUG - IS SOLE CHECKING");
    
    if((isSoleDivorcee || isSolePR) && hasChildInOccupier){
      return { pass: true, message: <p style={{fontSize:"1.125rem"}}>Sole SPR owner unable to retain the flat. Please refer to eligibility <a rel="noopener noreferrer" href={HDBLinks.eligibility_msg.eligible_condition} target="_blank" className="polymer-text-links">conditions</a>.</p> , debug: ""};
    }
    else{
      console.log("DEBUG - GENERAL CHECKING");
      return ageCheck(proposedOwners, proposedOccupiers, allowBypass35YearsOldCheck);
    }
  }
  else if(isDoubled){
    console.log("DEBUG - DOUBLED CHECKING");

    if((household.incoming_occupiers.length === 0 && household.incoming_owners.every(e=>e.myinfo.marital_status === MaritalStatusEnum.married)) || (household.incoming_owners.length === 0 && household.incoming_occupiers.every(e=>e.myinfo.marital_status === MaritalStatusEnum.married)) || (household.incoming_owners.every(e=>e.myinfo.marital_status === MaritalStatusEnum.married && household.incoming_occupiers.every(e=>e.myinfo.marital_status === MaritalStatusEnum.married)))){
      console.log("DEBUG - IS MARRIED CHECKING");
      return { pass: true, message: "" , debug: ""};
    }
    else{
      console.log("DEBUG - GENERAL CHECKING");
      return ageCheck(proposedOwners, proposedOccupiers, allowBypass35YearsOldCheck);
    }
  }
  else{

    console.log("DEBUG - GENERAL CHECKING");
    return ageCheck(proposedOwners, proposedOccupiers, allowBypass35YearsOldCheck);
  }

}

export const step1SchemeCheckingEligibility = async (data: ApplicationStep1, uinfin: string, flat_type?: FlatRoomTypeEnum, mop_status?: MopCheckStatusEnum | undefined, currentHoldingType?: HoldingTypeEnum, hasExecutorAdministrator?: boolean) => {
  console.log("DEBUG STEP 1 SCHEME ELIGIBILY data",data, uinfin, flat_type, mop_status);
  const currentOwners = data?.household.owners;
  const allIncomingOwners = data?.household.incoming_owners;
  const retainingIncomingOwners = data?.household.incoming_owners?.filter((owner) => owner.structure_status === StructureStatusEnum.retaining);
  const outgoingOwners = data?.household.owners?.filter((owner) => !data.household.incoming_owners.some(item => owner.myinfo.uinfin === item.myinfo.uinfin) || owner.structure_status === StructureStatusEnum.outgoing);
  const newIncomingOwners = data?.household.incoming_owners?.filter((owner) => owner.structure_status === StructureStatusEnum.incoming);
  const ownerToOccupier = getOwnerToOccupier(data.household);

  const allCurrentOwnersRetain = retainingIncomingOwners?.length === currentOwners?.length && 
  currentOwners.every(item => retainingIncomingOwners.some(owner => owner.myinfo.uinfin === item.myinfo.uinfin));

  const { change_ownership_reason } = data.reason;

  const currentOwnersUinfin = currentOwners.map((owner) => owner.myinfo.uinfin);
  const incomingOwnersUinfin = allIncomingOwners.map((owner) => owner.myinfo.uinfin);

  const initialCheckResult = initialCheck(data?.household, flat_type!, allCurrentOwnersRetain, allIncomingOwners, newIncomingOwners, mop_status, hasExecutorAdministrator);
  if (!initialCheckResult.pass) {
    return { eligible: false, message: initialCheckResult?.message, debug: initialCheckResult.debug };
  }


  const { isAddingWithoutRemoving, isRemovingWithoutAdding } = checkOwners( currentOwnersUinfin, incomingOwnersUinfin, currentOwners.length, allIncomingOwners.length);
  const isCompletelyChanged = retainingIncomingOwners?.length === 0

  switch (change_ownership_reason) {
    case OwnershipReasonEnum.divorce: {
      const result = checkEligibilityForDivorce(isAddingWithoutRemoving, allCurrentOwnersRetain, hasExecutorAdministrator ?? false);
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
      break;
    }

    case OwnershipReasonEnum.financial_difficulties: {
      const result = checkEligibilityForFinancialDifficulties(
        isRemovingWithoutAdding,
        currentOwners.length,
        allIncomingOwners.length
      );
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
      break;
    }

    case OwnershipReasonEnum.demise_of_current_owner: {
      const result = checkEligibilityForDemise(outgoingOwners, allIncomingOwners, newIncomingOwners, currentHoldingType)
      if (!result.pass) {
        return { eligible: false, message: result.message, debug: result.debug}
      }
      break;
    }

    case OwnershipReasonEnum.renunciation: {
      const result = checkEligibilityForRenunciation(isAddingWithoutRemoving, isCompletelyChanged, allCurrentOwnersRetain, mop_status, hasExecutorAdministrator ?? false);
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
      break;
    }

    case OwnershipReasonEnum.inclusion_due_to_marriage: {
      const result = checkEligibilityForInclusion(
        isRemovingWithoutAdding,
        isCompletelyChanged,
        newIncomingOwners.length,
        currentOwners,
        retainingIncomingOwners,
        hasExecutorAdministrator ?? false
      );
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
      break;
    }

    case OwnershipReasonEnum.moving_out_due_to_marriage: {
      const result = checkEligibilityForMovingOutMarriage(isAddingWithoutRemoving, allCurrentOwnersRetain, data.household, hasExecutorAdministrator ?? false);
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
      break;
    }

    case OwnershipReasonEnum.moving_out_others: {
      const result = await checkEligibilityForOtherReasons(isAddingWithoutRemoving, ownerToOccupier, uinfin, mop_status);
      if (!result.pass) {
        return { eligible: false, message: result.message };
      }
    }
  }

  if(!checkMovingOutMarriageCoupleValid(data.household)){
    console.log("As spousal relationship is considered as one entity, the spouse will need to be included as an owner or occupier before proceeding.");
    return { eligible: false, message: "As spousal relationship is considered as one entity, the spouse will need to be included as an owner or occupier before proceeding.", debug: "[checkMovingOutMarriageCoupleValid] - As spousal relationship is considered as one entity, the spouse will need to be included as an owner or occupier before proceeding." };
  }

  if(checkIsDecoupling(data)){
    console.log("Decoupling");
    return { eligible: false, message: "As spousal relationship is considered as one entity, the spouse will need to be included as an owner or occupier before proceeding.", debug: "[checkIsDecoupling] - As spousal relationship is considered as one entity, the spouse will need to be included as an owner or occupier before proceeding." };
  }

  const checkProposedHouseholdLiveStatusResult = checkProposedHouseholdLiveStatusValid(data);
  if(!checkProposedHouseholdLiveStatusResult.pass){
    return { eligible: false, message: checkProposedHouseholdLiveStatusResult.message, debug: checkProposedHouseholdLiveStatusResult.message }
  }

  const bypass35YearsOldCheck = checkNeedBypass35YearsOld(data.household, data.reason);
  const parentChildSchemeResult = eligibilityScheme(data?.household, bypass35YearsOldCheck);
  if (!parentChildSchemeResult.pass) {
    return { eligible: false, message: parentChildSchemeResult?.message, debug: `Eligibility Scheme not pass [${parentChildSchemeResult?.message.toString()}]` };
  }

  return { eligible: true, message: "" };
};

function initialCheck(householdFormData: HouseholdFormData, flat_type: FlatRoomTypeEnum, allCurrentOwnersRetain: boolean, allIncomingOwners: Owner[], newIncomingOwners: Owner[], mop_status?: MopCheckStatusEnum | undefined, hasExecutorAdministrator?: boolean) {
  const { check_has_private_property, check_has_dispose_property } = householdFormData;

  if(mop_status === MopCheckStatusEnum.N && (check_has_dispose_property || check_has_private_property)){
    console.log("DEBUG ELIGIBILITY - MOP not met, cannot dispose and has private property");
    return { pass: false, message: "Based on the information you have provided above, the proposed owners are not eligible for the Change in Flat Ownership.", debug: "MOP not met, cannot dispose and has private property."}
  }

  const numberOfCitizens = allIncomingOwners.reduce(
    (accumulator, owner) => accumulator + (owner.myinfo.residential_status === ResidentialStatusEnum.citizen ? 1 : 0),
    0
  );
  if (check_has_private_property && numberOfCitizens < 1) {
    return { pass: false, message: "Based on the information you have provided above, the proposed owners are not eligible for the Change in Flat Ownership.", debug: "No Singapore Citizen, cannot own private property." };
  }

  // const hasSPRLessThan3Years = householdFormData.incoming_owners.some(e=> e.myinfo.residential_status === ResidentialStatusEnum.pr && !checkDOB(e.spr_obtained_date, 3));
  if(householdFormData.incoming_owners.every(item => item.myinfo.residential_status === ResidentialStatusEnum.pr)){
      if(householdFormData.incoming_owners.some(item => !checkDOB(item.spr_obtained_date, 3))){
        console.log("DEBUG ELIGIBILITY - Cannot have SPR less than 3 years");
        return { pass: false, message: "Based on the information you have provided above, you are ineligible as one or more owners have not obtained SPR for more than 3 years.", debug: "Full SPR household, must everyone obtained PR more than 3 years." };
      }
  }
  /**
   * Note: check has larger thn 4 room flat and age
   */
  const hasLarger4RoomFlat = Object.values(FlatRoomTypeEnum).includes(flat_type);
  if (mop_status === MopCheckStatusEnum.N && check_has_dispose_property && (hasLarger4RoomFlat || !checkDOB(allIncomingOwners[0].myinfo.dob, 55))) {
    console.log("DEBUG ELIGIBILITY - hasLarger4RoomFlat");

    return { pass: false, message: "Based on the information you have provided above, the proposed owners are not eligible for the Change in Flat Ownership.", debug: `MOP not met, owner private property, ${hasLarger4RoomFlat ? "has larger 4 room flat" : ""}, ${!checkDOB(allIncomingOwners[0].myinfo.dob, 55) ? "first owner below 55 years old" : ""}` };
  }

  const sameStructure = allCurrentOwnersRetain && newIncomingOwners.length === 0;
  if (sameStructure && !hasExecutorAdministrator) {
    return { pass: false, message: "There is no change in ownership indicated. The current and proposed owners are the same.", debug: "No household structure change." };
  }


  return { pass: true, message: "" , debug: ""};
}

function checkOwners(
  currentOwnersUinfin: string[],
  incomingOwnersUinfin: string[],
  totalNumOfCurrentOwners: number,
  totalNumOfIncomingOwners: number
) {
  let currentOwnerChangedCount = 0;
  let incomingOwnerChangedCount = 0;

  for (let uinfin of currentOwnersUinfin) {
    if (incomingOwnersUinfin.includes(uinfin)) continue;
    currentOwnerChangedCount++;
  }

  for (let uinfin of incomingOwnersUinfin) {
    if (currentOwnersUinfin.includes(uinfin)) continue;
    incomingOwnerChangedCount++;
  }

  return {
    isAddingWithoutRemoving: currentOwnerChangedCount === 0 && totalNumOfCurrentOwners < totalNumOfIncomingOwners,
    isRemovingWithoutAdding: incomingOwnerChangedCount === 0 && totalNumOfCurrentOwners > totalNumOfIncomingOwners,
  };
}

function checkEligibilityForDivorce(isAddingWithoutRemoving: boolean, allCurrentOwnersRetain: boolean, hasExecutorAdministrator: boolean) {
  if (isAddingWithoutRemoving) {
    return { eligible: false, message: "A change in flat ownership due to divorce should have an outgoing owner." };
  }
  if (allCurrentOwnersRetain && !hasExecutorAdministrator) {
    return { pass: false, message: "An outgoing owner is required.", debug: "Outgoing owner required(Divorce)" };
  }
  return { pass: true, message: "", debug: ""};
}

function checkEligibilityForFinancialDifficulties(
  isRemovingWithoutAdding: boolean,
  currentOwnersLength: number,
  incomingOwnersLength: number
) {
  if (isRemovingWithoutAdding) {
    return { pass: false, message: "A change in flat ownership due to financial difficulties should have an incoming owner.", debug: "Incoming owner required(financial)" };
  }
  return { pass: true, message: "", debug: ""};
}

function checkEligibilityForDemise(outgoingOwners: Owner[], allIncomingOwners: Owner[], newIncomingOwners: Owner[], currentHoldingType: HoldingTypeEnum | undefined) {
  const isAnyIncomingOwnerDead = allIncomingOwners.some((outgoingOwner) => outgoingOwner.live_status === "D")
  if (isAnyIncomingOwnerDead) {
    return { pass: false, message: "Proposed owners includes dead person(s)", debug: "Proposed owners includes dead person(s)"}
  }
  
  const areAllOutgoingOwnersDead = outgoingOwners.every((outgoingOwner) => outgoingOwner.live_status === "D")
  if (currentHoldingType === HoldingTypeEnum.joint_tenancy && outgoingOwners.length > 0 && areAllOutgoingOwnersDead && newIncomingOwners.length === 0) {
    return { pass: false, message: "Only Notice of Death is required. Please approach your managing HDB branch for assistance.", debug: "No change in household structure except for dead outgoing owners"}
  }
  
  return { pass: true, message: "", debug: ""};
}

function checkEligibilityForRenunciation(
  isAddingWithoutRemoving: boolean,
  isCompletelyChanged: boolean,
  allCurrentOwnersRetain: boolean,
  mop_status: MopCheckStatusEnum | undefined = undefined,
  hasExecutorAdministrator: boolean
) {
  if (isAddingWithoutRemoving) {
    return { pass: false, message: "A change in flat ownership due to renunciation must have an outgoing owner.", debug: "Outgoing owner required(renunciation)." };
  }
  if (isCompletelyChanged && mop_status === MopCheckStatusEnum.N) {
    return { pass: false, message: "A change in flat ownership is not allowed as you have not fulfilled the minimum occupation period.", debug: "MOP not met, cannot change the household structure fully." };
  }
  if (allCurrentOwnersRetain && !hasExecutorAdministrator) {
    return { pass: false, message: "An outgoing owner is required.", debug: "Outgoing owner required(renunciation)" };
  }
  return { pass: true, message: "", debug: ""};
}

function checkEligibilityForInclusion(
  isRemovingWithoutAdding: boolean,
  isCompletelyChanged: boolean,
  numberOfNewIncomingOwners: number,
  currentOwner: Owner[],
  retainingIncomingOwners: Owner[],
  hasExecutorAdministrator: boolean
) {
  if (isRemovingWithoutAdding) {
    return { pass: false, message: "An inclusion in flat ownership due to marriage should have an incoming owner.", debug: "Incoming owner required(inclusion due to marriage)" };
  }
  if (isCompletelyChanged) {
    return { pass: false, message: "Cannot change ownership structure completely due inclusion because of marriage.", debug: "Cannot change household structure completely(inclusion due to marriage)" };
  }
  if (numberOfNewIncomingOwners <= 0 && !hasExecutorAdministrator) {
    return { pass: false, message: "Required a new owner", debug: "New owner required(inclusion due to marriage)" };
  }
  if (retainingIncomingOwners.length === 0) {
    //When current owner is only length 1, then ignore the retainingIncomingOwner.length === currentOwner.length checking.
    return { pass: false, message: "For inclusion due to marriage, there should be an addition of 1 new owner required.", debug: "Must have retaining owner(inclusion due to marriage)"};
  }

  return { pass: true, message: "", debug: ""};
}

function checkEligibilityForMovingOutMarriage(isAddingWithoutRemoving: boolean, allCurrentOwnersRetain: boolean, householdFormData: HouseholdFormData, hasExecutorAdministrator: boolean) {
  if (isAddingWithoutRemoving) {
    return { pass: false, message: "A change in flat ownership due to moving out due to marriage should have an outgoing owner.", debug: "Outgoing owner required(moving out due to marriage)" };
  }
  if (allCurrentOwnersRetain && !hasExecutorAdministrator) {
    return { pass: false, message: "An outgoing owner is required.", debug: "Outgoing owner required(Moving out marriage)" };
  }
  
  return { pass: true, message: "", debug: ""};
}

async function checkEligibilityForOtherReasons(isAddingWithoutRemoving: boolean, ownerToOccupier: Occupier[], uinfin: string, mop_status: MopCheckStatusEnum | undefined = undefined) {
  if (isAddingWithoutRemoving) {
    return { pass: false, message: "A change in flat ownership due to owner moving out should have an outgoing owner.", debug: "Outgoing owner required(moving out due to other reason)" };
  }
  if (mop_status === "N") {
    return { pass: false, message: "Changing ownership structure due moving out because of other reasons must meet minimum occupation period.", debug: "Changing household structure need to meet MOP." };
  }
  if (ownerToOccupier.length > 0) {
    const nrics = ownerToOccupier.map((e) => e.myinfo.uinfin);
    let error = await checkOwnerToOccupierFlatStatus(nrics, uinfin).then((res) => {
      if (res === false) {
        return { pass: false, message: "There is an owner or occupier listed in another HDB flat. Please remove existing ownership or occupier status before submitting a change in flat ownership application.", debug: "Proposed owner/occupier listed in another flat." };
      }
    });
    if (error) {
      return error;
    }
  }
  return { pass: true, message: "", debug: ""};
}

function getOwnerToOccupier(householdFormData: HouseholdFormData) {
  return householdFormData.incoming_occupiers?.filter(
    (occupier) =>
      occupier.structure_status !== StructureStatusEnum.incoming && householdFormData.owners.map((e) => e.myinfo.uinfin).includes(occupier.myinfo.uinfin)
  );
}

function ageCheck(proposedOwners: Owner[], proposedOccupiers: Occupier[], allowBypass35YearsOldCheck: boolean){
  const allProposedPersons = [...proposedOwners, ...proposedOccupiers];
  const numberOfMarriedPersons = allProposedPersons.reduce((accumulator, person) => {
    const isMarried = person.myinfo.marital_status === MaritalStatusEnum.married
    return accumulator + (isMarried ? 1 : 0);
  }, 0)
  if (numberOfMarriedPersons >= 2) {
    return { pass: true, message: "", debug: ""};
  }

  const isSoleOwner = proposedOwners.length === 1;
  const hasChildren = proposedOccupiers.some((occupier) => ["SO", "DA"].includes(occupier.relationship_with_owner));
  const isSingleParent = isSoleOwner && hasChildren;
  if (isSingleParent) {
    return { pass: true, message: "", debug: ""};
  }
  
  const atLeastOneOwner35 = proposedOwners?.some((owner) => checkDOB(owner.myinfo.dob, 35));
  if(!atLeastOneOwner35 && !allowBypass35YearsOldCheck){
    console.log("DEBUG ELIGIBILITY - AT LEAST NEED TO BE 35");
    return { pass: false, message: "Based on the information you have provided above, the proposed owners are not eligible for the Change in Flat Ownership.", debug: "At least one proposed owner need to be at least 35 years old."}
  }

  return { pass: true, message: "", debug: ""};

}


// function finalCheck(retainingIncomingOwners: Owner[], newIncomingOwners: Owner[], incomingOccupiers: Occupier[]) {
//   const hasMultipleApplicants = retainingIncomingOwners.length + newIncomingOwners.length > 1;
//   let atLeastOneOwner35 = retainingIncomingOwners?.some((owner) => checkDOB(owner.myinfo.dob, 35)) || newIncomingOwners?.some((owner) => checkDOB(owner.myinfo.dob, 35));
//   // Might need to double check, does not make sense when completely change, immediately pass the check
  
//   if(!atLeastOneOwner35 && hasMultipleApplicants){
//     console.log("DEBUG ELIGIBILITY - AT LEAST NEED TO BE 35");
//     return { pass: false, message: ""}
//   }
//   if (retainingIncomingOwners.length === 0 && atLeastOneOwner35) {
//     return { pass: true, message: ""}
//   }

//   if (atLeastOneOwner35 && hasMultipleApplicants) {
//     console.log("DEBUG ELIGIBILITY - Validate - 7a At least 1 owner > 35");
//     return { pass: true, message: "Validate - 7a At least 1 owner > 35" };
//   }

//   //!2 or more owners of immediate family relationship
//   if (newIncomingOwners.length > 0) {
//     console.log("DEBUG ELIGIBILITY - Point 7bi - 2 or more owners of immediate family relationship");
//     return { pass: true, message: "Point 7bi - 2 or more owners of immediate family relationship" };
//   }

//   //!Point 7.b.ii. - At least 1 owner and 1 occupier who is immediate family(spouse, child, parent, sibling)
//   const isRelated = incomingOccupiers?.some((occupier) => occupier.is_related === true);
//   if (incomingOccupiers.length > 0 && isRelated) {
//     console.log("DEBUG ELIGIBILITY - Point 7bii - At least 1 owner and 1 occupier who is immediate family(spouse, child, parent, sibling)");
//     return { pass: true, message: "Point 7bii - At least 1 owner and 1 occupier who is immediate family(spouse, child, parent, sibling)" };
//   }

//   console.log("FINAL CHECK");
//   return { pass: false, message: "" };
// }

function checkProposedHouseholdLiveStatusValid(applicationStep1FormData: ApplicationStep1){
  const currentDeadUinfins = applicationStep1FormData.household.owners.map(item => {
    return {
      uinfin: item.myinfo.uinfin,
      live_status: item.live_status
    }
  }).concat(applicationStep1FormData.household.occupiers.map(item => {
    return {
      uinfin: item.myinfo.uinfin,
      live_status: item.dod && item.dod !== "0001-01-01" ? "D" : "A"
    }
  })).filter(item => item.live_status === "D").map(item => item.uinfin);

  let proposedDeadUinfins: string[] = [];
  for(const owner of applicationStep1FormData.household.incoming_owners){
    if(currentDeadUinfins.includes(owner.myinfo.uinfin)){
        proposedDeadUinfins.push(owner.myinfo.uinfin);
    }
  }

  for(const occupier of applicationStep1FormData.household.incoming_occupiers){
    if(currentDeadUinfins.includes(occupier.myinfo.uinfin)){
      proposedDeadUinfins.push(occupier.myinfo.uinfin);
    }
  }

  proposedDeadUinfins = uniq(proposedDeadUinfins);

  const errorMessage = proposedDeadUinfins.length > 0 ? `The following applicants are deceased and cannot be included in the proposed household: ${proposedDeadUinfins.join(", ")}`: "";
  return { pass: proposedDeadUinfins.length === 0, message: errorMessage }
}

export const HDBPayableFeeValuation = (flat_type?: FlatRoomTypeEnum, valuation_value?:StampDutyValuationEnum) => {
  const year =  new Date().getFullYear();
  
  let adminFee = 20;
  let flat_fee = 0;
  let rate = 1.09;

  if (flat_type === FlatRoomTypeEnum.room1 || flat_type === FlatRoomTypeEnum.room2) {
    flat_fee = 140.0;
  } else {
    flat_fee = 210.0;
  }

  // if (year === 2023) {
  //   rate = 1.08; //8%
  // } else if (year >= 2024) {
  //   rate = 1.09; //9%
  // }

  let final_fee = flat_fee * rate + adminFee;
  return final_fee.toFixed(2);
};

export const checkNeedBypass35YearsOld = (household: HouseholdFormData, reason: ReasonFormData) => {
  const allProposedOwnersAreCurrentOccupiers = household?.incoming_owners.every(item => household?.occupiers.some(occupier => occupier.myinfo.uinfin === item.myinfo.uinfin));
  const currentOwnersAreDeadOrNoCurrentOwners = household?.owners.every(item => item.live_status === "D");
  return reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner && currentOwnersAreDeadOrNoCurrentOwners && allProposedOwnersAreCurrentOccupiers;
}

export const HousingSchemeChecking = (applicationStep1FormData: ApplicationStep1): HousingScheme => {
  const proposed_owners = applicationStep1FormData.household.incoming_owners;
  const proposed_occupiers = applicationStep1FormData.household.incoming_occupiers;

  const allowBypass35YearsOldCheck = checkNeedBypass35YearsOld(applicationStep1FormData.household, applicationStep1FormData.reason);
  if(allowBypass35YearsOldCheck){
      return { is_eligible: true, scheme_type: "" }
  }
  const isOrphan = false;
  const citizenSprResidentialStatus: string[] = [ResidentialStatusEnum.citizen, ResidentialStatusEnum.pr];
  if (proposed_owners.length < 1) {
    return { is_eligible: false, scheme_type: "" };
  }

  if (proposed_owners.length === 1) {
    const owner = proposed_owners[0];
    const isOver35 = checkDOB(owner.myinfo.dob, 35);
    const isOver21 = checkDOB(owner.myinfo.dob, 21);
    const hasOccupier = proposed_occupiers.length > 0;
    if(!citizenSprResidentialStatus.includes(owner.myinfo.residential_status)){
      return { is_eligible: false, scheme_type: "" };
    }

    if(owner.myinfo.residential_status === ResidentialStatusEnum.pr){
       if(!hasOccupier){
        return { is_eligible: false, scheme_type: "" };
       }

       const hasNonCitizenSprOccupier = proposed_occupiers.some(item => !citizenSprResidentialStatus.includes(item.myinfo.residential_status));

       if(hasNonCitizenSprOccupier){
        return { is_eligible: false, scheme_type: "" };
       }

       return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
    }
    const allOccupiersScSpr = proposed_occupiers.every(item => citizenSprResidentialStatus.includes(item.myinfo.residential_status));
    const parentRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Parent").map((item) => item.code);
    const childRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Child").map((item) => item.code);
    const hasParentOrChildren = proposed_occupiers.some(item => parentRelationshipCodes.includes(item.relationship_with_owner) || childRelationshipCodes.includes(item.relationship_with_owner));
    if (isOver35) {
      /** 
       * Note: this is check Single Singaporean Scheme
      */
      if(!hasOccupier){
        return { is_eligible: true, scheme_type: SchemeTypeEnum.single_spore_citizen };
      }

      if(allOccupiersScSpr){
         if(hasParentOrChildren){
          return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
         }
         return { is_eligible: false, scheme_type: "" };
      }

      const spouseRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Spouse").map((item) => item.code);
      const hasSpouse = proposed_occupiers.some((item) => spouseRelationshipCodes.includes(item.relationship_with_owner));
      if(hasSpouse){
        return { is_eligible: true, scheme_type: SchemeTypeEnum.non_citizen_spouse };
      }

      if(hasParentOrChildren){
        return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
      }

      const importantRelationship = ["Spouse", "Parent", "Child", "Sibling"];
      const importantRelationshipCodes = RelationshipWithOwner.filter(item => importantRelationship.includes(item.relationship)).map(item => item.code);
      const hasEssentialFamilyMember = proposed_occupiers.some(item => importantRelationshipCodes.includes(item.relationship_with_owner));
      if(hasEssentialFamilyMember){
         return { is_eligible: true, scheme_type: SchemeTypeEnum.orphan_sibling_scheme };
      }

      return { is_eligible: false, scheme_type: "" };
    }

    if (isOver21) {
      /** 
       * Note: this is check Single Mother Scheme
      */
     if(owner.myinfo.marital_status === MaritalStatusEnum.windowed){
      return { is_eligible: true, scheme_type: SchemeTypeEnum.single_mother };
     }

     if(hasOccupier){
        if(!allOccupiersScSpr){
          return { is_eligible: true, scheme_type: SchemeTypeEnum.non_citizen_family };
        }

        if(hasParentOrChildren){
          return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
        }
     }

     if(isOrphan){
      return { is_eligible: true, scheme_type: SchemeTypeEnum.orphan };
     }
      
    }
    return { is_eligible: false, scheme_type: "" };
  }

  const closeRelationship = ["FA", "MO", "HU", "WI", "SO", "DA", "BS"]; // [father, mother, husband, wife, son, daughter, brother/sister]
  const excludedL1Owners = proposed_owners.filter((e) => e.structure_order !== "L1");

  const allAreRelationship = excludedL1Owners.every((e) => closeRelationship.includes(e.relationship_with_owner));
  const allAreNotRelationship = excludedL1Owners.every((e) => !closeRelationship.includes(e.relationship_with_owner));

  const allAreOver35 = proposed_owners.every((e) => checkDOB(e.myinfo.dob, 35));
  const allAreSingaporeans = proposed_owners.every((e) => e.myinfo.residential_status === ResidentialStatusEnum.citizen);
  const allAreSingles = proposed_owners.every((e) => e.myinfo.marital_status === MaritalStatusEnum.single);

  if (allAreNotRelationship) {
    return checkEligibilityForAllAreNotRelationship(allAreOver35, allAreSingaporeans, isOrphan);
  }

  if (allAreRelationship) {
    return checkEligibilityForAllAreRelationship(allAreOver35, allAreSingaporeans, allAreSingles, proposed_owners);
  }

  return checkEligibilityForSomeAreRelationship(allAreOver35, allAreSingaporeans, allAreSingles, isOrphan);
};

function checkEligibilityForAllAreNotRelationship(allAreOver35: boolean, allAreSingaporeans: boolean, isOrphan: boolean) {
  if (allAreOver35) {
    if (allAreSingaporeans) {
      /** 
       * Note: Joint Single Scheme
      */
      return { is_eligible: true, scheme_type: SchemeTypeEnum.joint_single_schema };
    } else {
      return { is_eligible: false, scheme_type: "" }; // All are over 35 but not all are singaporeans
    }
  }

  if (isOrphan) {
    /** 
     * Note: ORPHAN Scheme
    */
    return { is_eligible: true, scheme_type: SchemeTypeEnum.orphan }; // Not all are over 35 but is orphan
  } else {
    return { is_eligible: false, scheme_type: "" }; // Not all are over 35 and is not orphan
  }
}

function checkEligibilityForAllAreRelationship(allAreOver35: boolean, allAreSingaporeans: boolean, allAreSingles: boolean, proposed_owners: Owner[]) {
  const allAreOver21 = proposed_owners.every((e) => checkDOB(e.myinfo.dob, 21));

  if (!allAreOver21) {
    return { is_eligible: false, scheme_type: "" }; // Not all are over 21
  }

  const excludedL1Owners = proposed_owners.filter((e) => e.structure_order !== "L1");

  const citizenSprResidentialStatus: string[] = [ResidentialStatusEnum.citizen, ResidentialStatusEnum.pr];
  const allCitizenOrSpr = proposed_owners.every(item => citizenSprResidentialStatus.includes(item.myinfo.residential_status));
  if (proposed_owners.length > 2) {
    const spouseRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Spouse").map((item) => item.code);
    const hasCouple = excludedL1Owners.find((e) => spouseRelationshipCodes.includes(e.relationship_with_owner));
    const parentRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Parent").map((item) => item.code);
    const hasParent = excludedL1Owners.find((e) => parentRelationshipCodes.includes(e.relationship_with_owner));
    const childRelationshipCodes = RelationshipWithOwner.filter((item) => item.relationship === "Child").map((item) => item.code);
    const hasChild = excludedL1Owners.find((e) => childRelationshipCodes.includes(e.relationship_with_owner));

    if (!hasCouple || !allCitizenOrSpr) {
      return { is_eligible: false, scheme_type: "" };
    }

    if (hasParent || hasChild) {
      /** 
       * Note: Public Applicant
      */
      return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
    }
    return { is_eligible: false, scheme_type: "" };
  }

  // proposed_owners.length === 2
  const allAreForeigners = proposed_owners.every((Owner) => {
    const residentialStatus = Owner.myinfo.residential_status;
    return residentialStatus !== ResidentialStatusEnum.citizen && residentialStatus !== ResidentialStatusEnum.pr;
  });
  if (allAreForeigners) {
    return { is_eligible: false, scheme_type: "" };
  }

  // if (!allAreSingaporeans) {//Original code
  //   /** 
  //    * Note: NCF - Non-Citizen Family
  //   */
  //   return { is_eligible: true, scheme_type: SchemeTypeEnum.non_citizen_family };
  // }

  if(!allCitizenOrSpr){//New code
    const hasCitizenSprAndForeigner = proposed_owners.some(item => citizenSprResidentialStatus.includes(item.myinfo.residential_status)) && proposed_owners.some(item => !citizenSprResidentialStatus.includes(item.myinfo.residential_status));
    if(hasCitizenSprAndForeigner){
      return { is_eligible: true, scheme_type: SchemeTypeEnum.non_citizen_family };
    }

    return { is_eligible: false, scheme_type: "" };
  }

  const importantRelationship = ["Spouse", "Parent", "Child", "Sibling"];
  const secondOwnerRelationship = RelationshipWithOwner.find((item) => item.code === excludedL1Owners[0].relationship_with_owner)?.relationship;
  if (!importantRelationship.includes(String(secondOwnerRelationship))) {
    return { is_eligible: false, scheme_type: "" };
  }

  // Is either Spouse, Parent, or Children
  if (secondOwnerRelationship !== "Sibling") {
    /** 
     * Note: PA - PUBLIC APPLICANT
    */
    return { is_eligible: true, scheme_type: SchemeTypeEnum.public_applicant };
  }

  // Is sibling
  if (allAreOver35 && allAreSingles) {
    /** 
     * Note: Joint Single Scheme
    */
    return { is_eligible: true, scheme_type: SchemeTypeEnum.joint_single_schema };
  }

  return { is_eligible: false, scheme_type: "" };
}

function checkEligibilityForSomeAreRelationship(allAreOver35: boolean, allAreSingaporeans: boolean, allAreSingles: boolean, isOrphan: boolean) {
  if (!allAreSingles) {
    return { is_eligible: false, scheme_type: "" }; // Not all are singles
  }

  return checkEligibilityForAllAreNotRelationship(allAreOver35, allAreSingaporeans, isOrphan);
}

export function checkIsFlatResale(sale_type_code: SalesCodeTypeEnum) {
  const RESALE_CODE:SalesCodeTypeEnum[] = [ "6", "6J", "7", "7C", "7J", "8A", "8B", "8C", "8D", "8E", "8F", "9", "9A", "9B", "8M", "8N" ];
  return RESALE_CODE.includes(sale_type_code);
}
export function checkIsFlatDirect(sale_type_code: SalesCodeTypeEnum) {
  const DIRECT_SALE_CODE:SalesCodeTypeEnum[] = [ "1" ,"1A" ,"1B" ,"10" ,"11" ,"12" ,"13" ,"14" ,"15" ,"18" ,"2" ,"2A" ,"2B" ,"3" ,"3A" ,"8" ,"8G" ,"8J" ,"8K" ,"8P" ,"8Q" ,"8L" ,"8T" ,"8R" ,"8S" ,"19" ];
  return DIRECT_SALE_CODE.includes(sale_type_code);
}
export function checkIsFlatNotApplicable(sale_type_code: SalesCodeTypeEnum) {
  const NOT_APPLICABLE_CODE:SalesCodeTypeEnum[] = [ "16", "17", "8H", "8I"];
  return NOT_APPLICABLE_CODE.includes(sale_type_code);
}

export function convertRaceToEthnicCode (race_code: RaceType | null){
  if(race_code === null){
    return "";
  }
  
  const foundEthnic = data.raceEthnic.find(e=>e.raceCode === race_code);

  if(foundEthnic){
    return foundEthnic.ethnicGroup;
  }
  else{
    switch(race_code){
      case "CN":
        return "C";
      case "MY":
        return "M";
      case "IN":
        return "I";
      default:
        return "";
    }
  }
}

export function convertRoleToStructureStatus (role: RoleNameType){
  if(role === "Executor"){
    return StructureStatusEnum.executor
  }
  else if(role === "Administrator"){
    return StructureStatusEnum.administrator
  }
  else if(role === "Deputy"){
    return StructureStatusEnum.deputy
  }
  else{
    return undefined
  }
}
export function convertStructureStatusToRole (role: StructureStatusEnum){
  if(role === StructureStatusEnum.executor){
    return "Executor"
  }
  else if(role === StructureStatusEnum.administrator){
    return "Administrator";
  }
  else if(role === StructureStatusEnum.deputy){
    return "Deputy";
  }
  else{
    return undefined
  }
}
